import { Modal } from "../../Modal";
import fragmentsIcon from './icons/fragments50.png';
import { FC } from "react";
import { Button } from "../../../Buttons/Button/Button";
import styles from "./NewFragmentNotify.module.scss";
import { Fragment } from "../../../Fragment/Fragment";

interface INewFragmentNotifyProps {
    closeHandler: () => void;
}

export const NewFragmentNotify: FC<INewFragmentNotifyProps> = ({ closeHandler }) => {
    const getContext = () => {
        return (
            <>
                <p>
                    <span>Вы получили еще</span>
                    <span className={styles.fragment}><Fragment /></span>
                    <span>1 фрагмент сертификата</span>
                </p>
                <p>Собрав 50 фрагментов вы получите сертификат Wildberries на 500 ₽.</p>                
                <p className={styles.list}><b>Фрагменты можно получить:</b>
                    <div>1. За приглашение друзей.</div>
                    <div>2. За прохождение испытаний.</div>
                    <div>3. За участие в интерактивном розыгрыше.</div>
                    <div>4. За сбор легендарной коллекции.</div>
                    <div>5. За активность в игре.</div>
                </p>
            </>
        );
    }

    return (
        <Modal
            name='NewFragmentNotify'
            title='Поздравляем!'
            message={ getContext() }
            icon={fragmentsIcon}
            button={ <Button caption='Закрыть' type='orange' handler={ () => closeHandler() } /> }
        />
    );
}